export default __webpack_public_path__ + "static/media/FOG_Events.9804a04f.mp4";